import React, { useState, useEffect } from "react";
import { DataGrid } from "@material-ui/data-grid";
import Spacer from "../../../components/Spacer";

export default function TimeTrackingTable(props) {

    const rows = props.rows;
    const column = [

        {
            field: "direction",
            headerName: "Direction",
            width: 200,
        },
        {
            field: "service",
            headerName: "Service",
            width: 150,
        },
        {
            field: "registration_number",
            headerName: "Matricule",
            width: 140,
        },
        {
            field: "Nom_prenom",
            headerName: "Nom et prénom(s)",
            width: 350,
        },
        {
            field: "Date_d_arrive",
            headerName: "Date du pointage",
            width: 190,
        },
        {
            field: "Type",
            headerName: "Période",
            width: 150,
        },
        {
            field: "Entree",
            headerName: "Entrée",
            width: 120,
            valueGetter: (params) => {
                const date = params.row.Date_d_arrive;
                const value = params.row.Statut;
                const [day, month, year] = date.split('/');

                const parsedMonth = parseInt(month) - 1;

                const parsedDate = new Date(year, parsedMonth, day);

                const today = new Date();
                if(
                    parsedDate.getDate() === today.getDate() &&
                    parsedDate.getMonth() === today.getMonth() &&
                    parsedDate.getFullYear() === today.getFullYear() &&
                    // value === "Absent" &&
                    params.row.Entree == "non"
                ){
                    return "En attente de synchronisation"
                }
                else {
                    return params.row.Entree;
                }
            }
        },
        {
            field: "Sortie",
            headerName: "Sortie",
            width: 120,
            valueGetter: (params) => {
                const date = params.row.Date_d_arrive;
                const value = params.row.Statut;
                const [day, month, year] = date.split('/');

                const parsedMonth = parseInt(month) - 1;

                const parsedDate = new Date(year, parsedMonth, day);

                const today = new Date();
                if(
                    parsedDate.getDate() === today.getDate() &&
                    parsedDate.getMonth() === today.getMonth() &&
                    parsedDate.getFullYear() === today.getFullYear() &&
                    // value === "Absent" &&
                    params.row.Sortie == "non"
                ){
                    return "En attente de synchronisation"
                }
                else {
                    return params.row.Sortie;
                }
            }
        },
        {
            field: "observation",
            headerName: "Observation",
            width: 350,
        },
        {
            field: "Statut",
            headerName: "Statut",
            valueGetter: (params) => {
                const date = params.row.Date_d_arrive;
                const value = params.row.Statut;
                const [day, month, year] = date.split('/');

                const parsedMonth = parseInt(month) - 1;

                const parsedDate = new Date(year, parsedMonth, day);

                const today = new Date();
                if(
                    parsedDate.getDate() === today.getDate() &&
                    parsedDate.getMonth() === today.getMonth() &&
                    parsedDate.getFullYear() === today.getFullYear() &&
                    value === "Absent"
                ){
                    return "En attente de synchronisation"
                }
                else {
                    return value;
                }
            },
            width: 240,
        },
    ];

    return (
        <React.Fragment>
            <Spacer y={1} />
            <div style={{ height: "70vh", width: "100%" }}>
                <DataGrid
                    rows={rows}
                    columns={column}
                    pageSize={9}
                    rowsPerPageOptions={[9]}
                    disableSelectionOnClick
                />
            </div>
        </React.Fragment>
    );
}
